import { Fragment } from 'react';
import { useLocation } from 'react-router-dom';

import classes from './Layout.module.css';
import MainNavigation from './MainNavigation';
import MarketPageShell from '../../../../components/MarketPageShell';

const Layout = (props) => {
  const location = useLocation();
  const path = location.pathname || '/';

  const showMarketShell =
    path === '/' ||
    path === '/leaders' ||
    path === '/marketflow' ||
    path.startsWith('/marketflow/ticker') ||
    path.startsWith('/capital');

  const showMainNavigation =
    !showMarketShell &&
    path !== '/login';

  return (
    <Fragment>
      {showMarketShell ? <MarketPageShell /> : null}
      {showMainNavigation ? <MainNavigation /> : null}
      <main className={classes.main}>{props.children}</main>
    </Fragment>
  );
};

export default Layout;
